var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{attrs:{"size":"mini"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }